import { FC } from 'react';
import { useRouteMatch, Route, Switch } from 'react-router-dom';
import List from './locations/List';

const MenuItemsLocation: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`} component={List} />
    </Switch>
  );
};

export default MenuItemsLocation;
